interface ConnectMoreDataProps {
  onConnect: () => void;
}

export const ConnectMoreData = ({ onConnect }: ConnectMoreDataProps) => {
  return (
    <div className="flex h-[124px] w-full flex-col items-center justify-between rounded-lg border border-[#65BA75] bg-[#3321DA] p-4">
      {/* Text Container */}
      <div className="flex w-full flex-col items-center gap-3">
        <h3 className="w-full text-center font-['National_2'] text-lg font-medium leading-[26px] tracking-[-0.04px] text-base-white">
          Connect more data for deeper checks
        </h3>
      </div>

      {/* Description Container */}
      <div className="flex w-full flex-row items-start gap-3">
        <p className="w-full text-center font-['National_2'] text-sm font-normal leading-5 text-base-white">
          Unlock full coverage with private brand guidelines, project files, and
          design assets.
        </p>
      </div>

      {/* Button */}
      <button
        onClick={onConnect}
        className="flex h-8 w-[123px] flex-row items-center justify-center gap-2 rounded-md bg-[#EEEEEC] px-3"
        data-testid="connect-more-data-button"
      >
        <span className="flex h-5 items-center font-['National_2'] text-sm font-medium leading-5 text-[#181816]">
          Connect
        </span>
        {/* <ArrowRight size={16} color="#181816" /> */}
      </button>
    </div>
  );
};
